export const view = {
  adjustment: {
    create: 'Create Adjustment',
    edit: 'Edit Adjustment',
    delete: 'Delete Adjustment',
  },
};
